<!--
 * @Description: 
-->
<template>
  <el-form :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.creditDealType"
        placeholder="奖惩类型"
      >
        <el-option
          v-for="(item, i) in creditDealTypeData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.creditYear"
        placeholder="奖惩年份"
      >
        <el-option
          v-for="(item, i) in creditYears"
          :key="i"
          :label="item.value"
          :value="item.key"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        v-model="filters.userName"
        placeholder="请输入姓名"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click.native="initData"></butn>
      <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>
<script>
import butn from "@/components/button/index";
import { getDataMap } from "@/api/sysParam";
export default {
  name: "search",
  components: {
    butn,
  },
  data() {
    return {
      filters: {},
      creditDealTypeData: [],
      creditYears: [],
    };
  },
  created() {
    getDataMap("CREDIT_DEAL_TYPE").then((res) => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        paramKey: "",
        //paramValue: "全部奖惩类型"
        paramValue: "全部",
      });
      this.creditDealTypeData = res.data;
    });
    let nowDate = new Date();
    let nowYear = nowDate.getFullYear();
    //this.creditYears.push({ key: "", value: "全部奖惩年份" });
    this.creditYears.push({ key: "", value: "全部" });
    for (let i = 0; i < 5; i++) {
      let year = nowYear - i + "年";
      this.creditYears.push({
        key: nowYear - i,
        value: year,
      });
    }
  },
  methods: {
    initData() {
      //查询
      this.$emit("search", { ...this.filters, t: new Date().getTime() });
    },
    resetData() {
      //重置
      this.filters = {};
      this.$emit("search", { t: new Date().getTime() });
    },
  },
};
</script>
